import React from 'react'
import { Label, Checkbox, Col } from '@evertel/web/ui'

interface TextTypeSelectorProps {
    onChange?: (value?: string | number | readonly string[]) => void
    value?: string
    label?: string
}

const TextTypeSelector: React.FC<TextTypeSelectorProps> = ({
    onChange,
    label,
    value,
    ...otherProps
}) => {

    const groupLabelId = `${label.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}-label`

    return (
        <Col {...otherProps}>
            <div id={groupLabelId} className="mb-2">{label}</div>

            <div
                role="radiogroup"
                aria-labelledby={groupLabelId}
                className="flex flex-wrap gap-2"
            >
                <Checkbox
                    className="m-1"
                    id="number"
                    label="Number"
                    value="number"
                    checked={value === 'number'}
                    onChange={(e) => onChange && onChange((e.checked) ? e.value : undefined)}
                    inputProps={{ role: 'radio' }}
                />
                <Checkbox
                    className="m-1"
                    id="url"
                    label="Link/URL"
                    value="url"
                    checked={value === 'url'}
                    onChange={(e) => onChange && onChange((e.checked) ? e.value : undefined)}
                    inputProps={{ role: 'radio' }}
                />
                <Checkbox
                    className="m-1"
                    id="email"
                    label="Email"
                    value="email"
                    checked={value === 'email'}
                    onChange={(e) => onChange && onChange((e.checked) ? e.value : undefined)}
                    inputProps={{ role: 'radio' }}
                />
                <Checkbox
                    className="m-1"
                    id="tel"
                    label="Phone Number"
                    value="tel"
                    checked={value === 'tel'}
                    onChange={(e) => onChange && onChange((e.checked) ? e.value : undefined)}
                    inputProps={{ role: 'radio' }}
                />
            </div>
        </Col>
    )
}

export default TextTypeSelector
TextTypeSelector.displayName = 'TextTypeSelector'
